// Реестр повторяемых старт-эмитов для восстановления стримов после реконнекта.
const REPLAYABLE_START_EVENTS = new Set([
  'coords_listen_start',
  'uipps_listen_start',
  'brigade_listen_start',
  'info_listen_start',
  'signals_listen_start',
]);

// Соответствие stop -> start для корректного удаления из реестра.
const STOP_TO_START_EVENT = {
  coords_listen_stop: 'coords_listen_start',
  uipps_listen_stop: 'uipps_listen_start',
  brigade_listen_stop: 'brigade_listen_start',
  info_listen_stop: 'info_listen_start',
  signals_listen_stop: 'signals_listen_start',
};

// Храним последний payload для каждого события.
const replayableEmits = new Map();

// Нормализация пути для route-guard при переэмите.
const normalizePathname = (pathname) => (typeof pathname === 'string' ? pathname : '');

// Сохраняем последний payload для listen_start, чтобы переэмитить после реконнекта.
export const registerReplayable = (eventName, payload, pathname) => {
  if (!REPLAYABLE_START_EVENTS.has(eventName)) return;
  const safePayload = payload && typeof payload === 'object' && !Array.isArray(payload) ? { ...payload } : payload;
  replayableEmits.set(eventName, {
    payload: safePayload,
    pathname: normalizePathname(pathname),
    ts: Date.now(),
  });
};

// Удаляем сохранённый start при получении соответствующего listen_stop.
export const unregisterReplayable = (eventName) => {
  if (!Object.prototype.hasOwnProperty.call(STOP_TO_START_EVENT, eventName)) return;
  const startEvent = STOP_TO_START_EVENT[eventName];
  if (!REPLAYABLE_START_EVENTS.has(startEvent)) return;
  replayableEmits.delete(startEvent);
};

export const replayAll = (socket, pathname) => {
  if (!socket) return;
  const currentPath = normalizePathname(pathname);
  replayableEmits.forEach((entry, eventName) => {
    // Переэмитим только для текущего маршрута, чтобы не оживлять старые страницы.
    if (entry.pathname && currentPath && entry.pathname !== currentPath) return;
    socket.emit(eventName, entry.payload);
  });
};

// Полная очистка реестра (например, при logout).
export const clearReplayable = () => {
  replayableEmits.clear();
};
